class FirehawkPay {
    checkoutWrapper = null;
    addressAutoComplete = null;

    paymentIntent = null;
    paymentElement = null;
    paymentRequest = null
    elements = null;

    formPage1 = null
    formPage2 = null
    formPage3 = null
    isSubmitting = false
    paymentFormComplete = false
    countries = null;

    loadingStripe = true
    hasInitialStripe = false

    client = null;
    type = null;

    stripePublishableKey = null
    cartCurrency = "usd"
    useTestPayments = false

    activePage = "firehawk-pay-page-1"

    constructor(element, countries = null, cartCurrency = null, useTestPayments = false, client = null, type = null) {
        this.countries = countries;
        this.checkoutWrapper = element
        this.client = client;
        this.type = type;

        if(cartCurrency && cartCurrency.length) {
            this.cartCurrency = cartCurrency;
        }

        this.useTestPayments = useTestPayments;

        this.formPage1 = jQuery(this.checkoutWrapper).find("#firehawk-pay-page-1")
        this.formPage2 = jQuery(this.checkoutWrapper).find("#firehawk-pay-page-2")
        this.formPage3 = jQuery(this.checkoutWrapper).find("#firehawk-pay-page-3")

        this.hideQuickCheckout()
        this.addListeners()
        this.setupGoogleAddress();
    }

    addListeners() {
        this.formPage1.validate({
            // Specify validation rules
            rules: {
                // The key name on the left side is the name attribute
                // of an input field. Validation rules are defined
                // on the right side
                firstName: {
                    required: true
                },
                lastName: {
                    required: true
                },
                amount: {
                    required: true,
                    min: 5
                }
            },
            // Specify validation error messages
            messages: {
                firstName: "Please enter your loved ones first name",
                lastName: "Please enter your loved ones last name",
                amount: "Please enter an amount of at least $5"
            }
        });

        this.formPage2.validate({
            // Specify validation rules
            rules: {
                contactFirstName: {
                    required: true
                },
                contactLastName: {
                    required: true
                },
                contactEmail: {
                    required: true,
                    email: true
                }
            },
            // Specify validation error messages
            messages: {
                contactFirstName: "Please enter your first name",
                contactLastName: "Please enter your last name",
                email: "Please enter a valid email address"
            }
        });

        this.formPage3.validate({
            // Specify validation rules
            rules: {
                street: {
                    required: true
                },
                city: {
                    required: true
                },
                state: {
                    required: true
                },
                postcode: {
                    required: true
                }
            },
            // Specify validation error messages
            messages: {
                street: "Please enter in a street address",
                city: "Please enter in a city",
                state: "Please enter in a state",
                postcode: "Please enter in a zip code"
            }
        });

        jQuery(this.checkoutWrapper).delegate("#form-page-next", 'click', (event) => {
            event.preventDefault()
            var errorView = jQuery(this.checkoutWrapper).find("#submit-error")
            this.configureStripe()
            if (this.activePage == "firehawk-pay-page-1") {
                if (!this.formPage1.valid()) {
                    errorView.html("Please fill out the required form fields before submitting")
                    errorView.removeClass("d-none")
                    return;
                }

                this.activePage = "firehawk-pay-page-2"
                jQuery(this.checkoutWrapper).find(".form-actions .back-btn").show()
                jQuery(this.checkoutWrapper).find(".form-actions .next-btn").show()
                jQuery(this.checkoutWrapper).find(".form-actions #submit-payment").hide()
                this.setupStripeQuickPay()
            } else if (this.activePage == "firehawk-pay-page-2") {
                if (!this.formPage2.valid()) {
                    errorView.html("Please fill out the required form fields before submitting")
                    errorView.removeClass("d-none")
                    return;
                }

                this.activePage = "firehawk-pay-page-3"

                jQuery(this.checkoutWrapper).find(".form-actions .back-btn").show()
                jQuery(this.checkoutWrapper).find(".form-actions .next-btn").hide()
                jQuery(this.checkoutWrapper).find(".form-actions #submit-payment").show()
                this.setupStripe();
            }

            jQuery(this.checkoutWrapper).find(".firehawk-pay-page").hide()
            jQuery(this.checkoutWrapper).find("#" + this.activePage).show()
        });

        jQuery(this.checkoutWrapper).delegate("#form-page-back", 'click', (event) => {
            event.preventDefault()
            if (this.activePage == "firehawk-pay-page-2") {
                this.activePage = "firehawk-pay-page-1"
                jQuery(this.checkoutWrapper).find(".form-actions .back-btn").hide()
                jQuery(this.checkoutWrapper).find(".form-actions .next-btn").show()
            } else if (this.activePage == "firehawk-pay-page-3") {
                this.activePage = "firehawk-pay-page-2"
                jQuery(this.checkoutWrapper).find(".form-actions .back-btn").show()
                jQuery(this.checkoutWrapper).find(".form-actions .next-btn").show()
                jQuery(this.checkoutWrapper).find(".form-actions #submit-payment").hide()
            }
            jQuery(this.checkoutWrapper).find(".firehawk-pay-page").hide()
            jQuery(this.checkoutWrapper).find("#" + this.activePage).show()
        });

        jQuery(this.checkoutWrapper).delegate("#submit-payment", 'click', (event) => {
            event.preventDefault()
            this.submitPayment();
        });

        jQuery(this.checkoutWrapper).delegate("input[name=amount]", 'change', (event) => {
            event.preventDefault()
            let current = jQuery(event.currentTarget)
            var value = current.val()
            var amount = +(value || 0)
            var errorView = jQuery(this.checkoutWrapper).find("#submit-error")


            if (amount > 0) {
                errorView.addClass("d-none")
            } else {
                errorView.html("Please enter an amount greater than 0")
                errorView.removeClass("d-none")
            }
        });

        jQuery(this.checkoutWrapper).delegate("select[name=country]", 'change', (event) => {
            event.preventDefault();
            let current = jQuery(event.currentTarget);
            let optionSelected = jQuery(current).val();

            if (optionSelected && optionSelected.length) {
                let foundCountry = this.countries.find((c) => c && c.name == optionSelected)

                if (foundCountry && foundCountry["alpha-2"] && this.addressAutoComplete) {
                    this.addressAutoComplete.setComponentRestrictions({
                        'country': foundCountry["alpha-2"]
                    })
                } else if (this.addressAutoComplete) {
                    this.addressAutoComplete.setComponentRestrictions({
                        'country': null
                    })
                }

                jQuery.ajax({
                    method: 'post',
                    url: ajax_var.url,
                    data: {
                        action: 'fh_fetch_states',
                        params: {
                            country: foundCountry.id || null
                        }
                    }
                }).done((res) => {
                    let response = JSON.parse(res);

                    let pickerField = jQuery(this.checkoutWrapper).find("select[name=state]");
                    let inputField = jQuery(this.checkoutWrapper).find("input[name=state]");
                    pickerField.empty();

                    if (response && response.result && response.result.length) {
                        // Show select field
                        pickerField.show()
                        pickerField.parent().show()

                        // Hide input field
                        inputField.hide()
                        inputField.parent().hide()
                        inputField.val('')

                        for (let state of response.result) {
                            let option = jQuery("<option></option>")
                                .attr("value", state.name).text(state.name)
                            pickerField.append(option)
                        }
                    } else {
                        // Hide select field
                        pickerField.hide()
                        pickerField.parent().hide()

                        // Show input field
                        inputField.show()
                        inputField.parent().show()
                    }
                });
            }
        });
    }

    setupGoogleAddress() {
        let element = document.getElementById("street");

        if (!element) return;

        this.addressAutoComplete = new google.maps.places.Autocomplete(element);

        let country = jQuery(this.checkoutWrapper).find('select[name="country"]').val()
        let foundCountry = this.countries.find((c) => c && c.name == country)

        if (foundCountry && foundCountry["alpha-2"]) {
            this.addressAutoComplete.setComponentRestrictions({
                'country': foundCountry["alpha-2"]
            })
        } else {
            this.addressAutoComplete.setComponentRestrictions({
                'country': ["US"]
            })
        }

        var googleListener = this.addressAutoComplete.addListener('place_changed', this.handleGoogleAddress.bind(this))
    }

    handleGoogleAddress() {
        var place = this.addressAutoComplete.getPlace()

        if (!place) return;

        var addressComponents = place["address_components"] || {}

        var city = this.findGoogleAddressPart(addressComponents, ['locality', 'sublocality', 'postal_town'], 'long_name') || ""
        var stateShort = this.findGoogleAddressPart(addressComponents, 'administrative_area_level_1', 'short_name') || ""
        var stateLong = this.findGoogleAddressPart(addressComponents, 'administrative_area_level_1', 'long_name') || ""
        var countyShort = this.findGoogleAddressPart(addressComponents, 'administrative_area_level_2', 'short_name') || ""
        var countyLong = this.findGoogleAddressPart(addressComponents, 'administrative_area_level_2', 'long_name') || ""
        var postcode = this.findGoogleAddressPart(addressComponents, 'postal_code', 'long_name') || ""
        var country = this.findGoogleAddressPart(addressComponents, 'country', 'long_name') || ""

        jQuery(this.checkoutWrapper).find("input[id='city']").val(city)

        var statePicker = jQuery('select[name="state"]');
        var stateField = jQuery('input[name="state"]');

        if (statePicker.length > 0 && statePicker.is('select')) {
            jQuery(statePicker).find("option").each(function () {
                this.selected = (this.text == stateLong);
            });
            if (jQuery(statePicker).data("select2")) {
                jQuery(statePicker).select2("data", {
                    id: stateLong,
                    text: stateShort
                })
                jQuery(statePicker).trigger('change')
            }
        } else if (stateField.length > 0) {
            stateField.val(stateShort)
        }

        jQuery(this.checkoutWrapper).find("input[id='county']").val(countyShort || countyLong);
        jQuery(this.checkoutWrapper).find("input[id='postcode']").val(postcode);
        jQuery(this.checkoutWrapper).find("select[id='country'] option").each(function () {
            this.selected = (this.text == country);
        });

        var subpremise = this.findGoogleAddressPart(addressComponents, 'subpremise', 'long_name') || ""
        var streetNumber = this.findGoogleAddressPart(addressComponents, 'street_number', 'long_name') || ""
        var street = this.findGoogleAddressPart(addressComponents, 'route', 'long_name') || ""

        var fullStreetNumber;
        if (subpremise && streetNumber) {
            fullStreetNumber = `${subpremise}/${streetNumber}`
        } else if (streetNumber) {
            fullStreetNumber = streetNumber
        }

        var line1 = "";

        if (fullStreetNumber && street) {
            line1 = `${fullStreetNumber} ${street}`
        } else if (street) {
            line1 = street
        }
        jQuery(this.checkoutWrapper).find("input[id='street']").val(line1)
        this.formPage3.valid()
    }

    findGoogleAddressPart(address_components, query, val = null) {
        for (let attr of address_components) {
            for (let type of attr.types) {
                if (Array.isArray(query) && query.filter(q => q == type).length > 0) {
                    return val ? attr[val] : attr;
                } else if (type === query) {
                    return val ? attr[val] : attr;
                }
            }
        }
        return null;
    }

    checkFormValid() {
        if (this.formPage1.valid() == false) return false;
        if (this.formPage2.valid() == false) return false;
        if (this.formPage3.valid() == false) return false;
        return true;
    }

    updateSubmitButton(status) {
        jQuery("#submit-payment").prop('disabled', status);
    }

    submitPayment() {
        if (this.isSubmitting) return;

        var errorView = jQuery(this.checkoutWrapper).find("#submit-error")
        var submitButton = jQuery(this.checkoutWrapper).find("#submit-payment")

        submitButton.addClass("loading")

        if (!this.checkFormValid()) {
            //TODO: Show form error;
            errorView.html("Please fill out the required form fields before submitting")
            errorView.removeClass("d-none")
            submitButton.removeClass("loading")
            return;
        }

        let amountValue = this.formPage1.find("input[name=amount").val()
        let amount = +(amountValue || 0)

        if (amount <= 0) {
            errorView.html("Please enter an amount greater than 0")
            errorView.removeClass("d-none")
            submitButton.removeClass("loading")
            return
        }

        if (!this.paymentFormComplete) {
            errorView.html("Please fill out the required payment details before submitting")
            errorView.removeClass("d-none")
            submitButton.removeClass("loading")
            return
        }

        errorView.addClass("d-none")

        let eles = this.elements;

        this.stripe.confirmPayment({
            elements: eles,
            redirect: "if_required",
        }).then((result) => {
            if (result.error) {
                // Inform the customer that there was an error.
                console.error("Error", error)
                errorView.html("Something has gone wrong. Please try again or contact us if the issue persists.")
                errorView.removeClass("d-none")
                submitButton.removeClass("loading")
                this.isSubmitting = false
                return;
            }

            let firstName = jQuery(this.checkoutWrapper).find('input[name="firstName"]').val()
            let lastName = jQuery(this.checkoutWrapper).find('input[name="lastName"]').val()
            let message = jQuery(this.checkoutWrapper).find('input[name="message"]').val()
            let contactFirstName = jQuery(this.checkoutWrapper).find('input[name="contactFirstName"]').val()
            let contactLastName = jQuery(this.checkoutWrapper).find('input[name="contactLastName"]').val()
            let street = jQuery(this.checkoutWrapper).find('input[name="street"]').val()
            let city = jQuery(this.checkoutWrapper).find('input[name="city"]').val()
            let pickerState = jQuery(this.checkoutWrapper).find('select[name="state"]').val()
            let fieldState = jQuery(this.checkoutWrapper).find('input[name="state"]').val()
            let county = jQuery(this.checkoutWrapper).find('input[name="county"]').val()
            let country = jQuery(this.checkoutWrapper).find('select[name="country"]').val()
            let postcode = jQuery(this.checkoutWrapper).find('input[name="postcode"]').val()
            let contactEmail = jQuery(this.checkoutWrapper).find('input[name="contactEmail"]').val()
            let contactPhone = jQuery(this.checkoutWrapper).find('input[name="contactPhone"]').val()

            let params = {
                paymentDetails: {
                    amount: amount,
                    firstName: firstName || null,
                    lastName: lastName || null,
                    message: message || null,
                    contactFirstName: contactFirstName || null,
                    contactLastName: contactLastName || null,
                    contactEmail: contactEmail || null,
                    contactPhone: contactPhone || null,
                    address: [{
                        street: street || null,
                        city: city || null,
                        state: pickerState || fieldState || null,
                        county: county || null,
                        country: country || null,
                        postcode: postcode || null
                    }],
                    client: this.client || null,
                    type: this.type || null,
                    currency: this.cartCurrency || null
                },
                paymentIntent: this.paymentIntent || null
            };

            jQuery.ajax({
                method: 'post',
                url: ajax_var.url,
                data: {
                    action: 'submit_firehawk_pay',
                    params: params
                }
            }).done((res) => {
                jQuery(this.checkoutWrapper).find(".firehawk-pay-form").hide()
                jQuery(this.checkoutWrapper).find(".firehawk-pay-success").show()
                submitButton.removeClass("loading")
            }).fail((xhr, status, error) => {
                console.error("Error", error)
                errorView.html("Something has gone wrong. Please try again or contact us if the issue persists.")
                errorView.removeClass("d-none")
                submitButton.removeClass("loading")
                this.isSubmitting = false
            })
        }).catch((error) => {
            console.error("Error", error)
            errorView.html("Something has gone wrong. Please try again or contact us if the issue persists.")
            errorView.removeClass("d-none")
            submitButton.removeClass("loading")
            this.isSubmitting = false
        })
    }

    configureStripe() {
        if (this.stripe) return;

        let liveStripeAu = "pk_live_51HyO42F2bX2kTVtiLQbImMOe6VW5pIFd2mIRJ0SdYMvrSRa7BvaWvwr46hlOMP6GPPe0wX0oInJXLQkIcfBXMsPE00xgM7qEgI";
		let liveStripeUsd = "pk_live_51KyUfFL6cJQBjiCc0VN2wKDAT7SjjAYBRl1ho1o9Lg6b7dFwyM61lDpk9RI3NTimppdOCtBlrP4IbY4ehk9nybzU005ECfSwQ8";
		let testStripeAu = "pk_test_51HyO42F2bX2kTVtibwiGBRz0NODYQAkYYlr0eDT34Jle6i3AQZQ2Q9ClTf455EDVfatn9AvmQG3cbaKfDlmwputC00i1vFVPWD";
		let testStripeUsd = "pk_test_51KyUfFL6cJQBjiCccmZRdC9aCebmimF8uQkEbVKlKJay9YdGL2vJtSiTUFOOpcS7PlMsHFIPCBFKpw3cIWO5mYkg0086sV4c5D";
		let liveStripe = null;

		if (this.cartCurrency == "usd") {
			if (this.useTestPayments) {
				liveStripe = testStripeUsd;
			} else {
				liveStripe = liveStripeUsd;
			}
		} else if (this.cartCurrency == "aud") {
			if (this.useTestPayments) {
				liveStripe = testStripeAu;
			} else {
				liveStripe = liveStripeAu;
			}
		}

        let stripeKey = liveStripe;
		this.stripe = Stripe(stripeKey);
    }

    setupStripeQuickPay() {
        let me = this
        let amountValue = this.formPage1.find("input[name=amount").val()
        let amount = +(amountValue || 0)

        if (!amount) return;

        const paymentRequest = this.stripe.paymentRequest({
            country: 'US',
            currency: 'usd',
            total: {
                label: 'FireHawkPay',
                amount: Math.round(amount*100),
            },
            requestPayerName: true,
            requestPayerEmail: true,
            requestPayerPhone: true, 
            requestShipping: true,
            shippingOptions: [
                {
                  id: 'free-shipping',
                  label: 'Free shipping',
                  detail: '',
                  amount: 0,
                }
            ]
        });

        const elements = this.stripe.elements();
        const prButton = elements.create('paymentRequestButton', {
            paymentRequest,
        });

        // Check the availability of the Payment Request API first.
        paymentRequest.canMakePayment().then((result) => {
            if (result && (result.applePay || result.googlePay)) {
                prButton.mount('#fh-pay-checkout-request-button');
                this.createPaymentRequestIntent(amount)
            } else {
                this.hideQuickCheckout()
            }
        }).catch((error) => {
            console.error(error)
            this.hideQuickCheckout()
        })

        paymentRequest.on('paymentmethod', (ev) => {
            this.handlePaymentRequest(ev, amount)
        });
    }

    handlePaymentRequest(ev, amount) {
        var errorView = jQuery(this.checkoutWrapper).find("#submit-error")
        var submitButton = jQuery(this.checkoutWrapper).find("#submit-payment")

        submitButton.addClass("loading")

        // Confirm the PaymentIntent without handling potential next actions (yet).
        this.stripe.confirmCardPayment(
            this.paymentIntent.client_secret,
            { payment_method: ev.paymentMethod.id },
            { handleActions: false }
        ).then(({ paymentIntent, error: confirmError }) => {
            if (confirmError) {
                // Report to the browser that the payment failed, prompting it to
                // re-show the payment interface, or show an error message and close
                // the payment interface.
                ev.complete('fail');
                console.error("Error", confirmError)
                errorView.html("Something has gone wrong. Please try again or contact us if the issue persists.")
                errorView.removeClass("d-none")
                submitButton.removeClass("loading")
                this.isSubmitting = false
            } else {
                // Report to the browser that the confirmation was successful, prompting
                // it to close the browser payment method collection interface.
                ev.complete('success');

                // Check if the PaymentIntent requires any actions and if so let Stripe.js
                // handle the flow. If using an API version older than "2019-02-11"
                // instead check for: `paymentIntent.status === "requires_source_action"`.
                if (paymentIntent.status === "requires_action") {
                    // Let Stripe.js handle the rest of the payment flow.
                    this.stripe.confirmCardPayment(clientSecret).then((results) => {
                        if (error) {
                            // The payment failed -- ask your customer for a new payment method.
                            console.error("Error", error)
                            errorView.html("Something has gone wrong. Please try again or contact us if the issue persists.")
                            errorView.removeClass("d-none")
                            submitButton.removeClass("loading")
                            this.isSubmitting = false
                        } else {
                            // The payment has succeeded.
                            //TODO: Process payment
                            this.finaliseQuickCheckout(ev, amount)
                        }
                    })                    
                } else {
                    // The payment has succeeded.
                    //TODO: Process payment
                    this.finaliseQuickCheckout(ev, amount)
                }
            }
        })
    }

    showQuickCheckout() {
        jQuery("#fh-pay-checkout-request-button").show()
        jQuery("#quick-checkout-title").show()
        jQuery("#fh-pay-checkout-request-button").next(".or-divider").show();
    }

    hideQuickCheckout() {
        jQuery("#fh-pay-checkout-request-button").hide()
        jQuery("#quick-checkout-title").hide()
        jQuery("#fh-pay-checkout-request-button").next(".or-divider").hide();
    }

    createPaymentRequestIntent(amount) {
        let params = {
            amount: amount,
            testPayment: this.useTestPayments == true
        };

        if(this.client) {
            params["client"] = this.client
        }

        if(this.type) {
            params["meta_type"] = this.type
        }

        if(this.useTestPayments) {
            params['testPayment'] = true
        }

        if(this.currency) {
            params['currency'] = currency
        }

        jQuery.ajax({
            method: 'post',
            url: ajax_var.url,
            data: {
                action: 'firehawk_pay_payment_intent',
                params: params
            }
        }).done((response) => {
            if (response && response.result && response.result.client_secret) {
                this.paymentIntent = response.result;
                this.showQuickCheckout()
            } else {
                this.hideQuickCheckout()
            }
        }).fail((xhr, status, error) => {
            console.log(status, error)
            this.hideQuickCheckout()
        })
    }

    finaliseQuickCheckout(results, amount) {
        var errorView = jQuery(this.checkoutWrapper).find("#submit-error")
        var submitButton = jQuery(this.checkoutWrapper).find("#submit-payment")

        let name = results.payerName

        let names = (name || "").split(" ")
        var contactFirstName = names[0] || null
        var contactLastName = names[1] || null
        let contactEmail = results.payerEmail
        let contactPhone = results.payerPhone


        let firstName = jQuery(this.checkoutWrapper).find('input[name="firstName"]').val()
        let lastName = jQuery(this.checkoutWrapper).find('input[name="lastName"]').val()
        let message = jQuery(this.checkoutWrapper).find('input[name="message"]').val()
        
        let address = results.shippingAddress
        let street = address && address.addressLine ? address.addressLine.join(", ") : null
        let city = address && address.city || null
        let region = address && address.region || null

        let countryCode = address && address.country || null
        let postcode = address && address.postalCode || null

        var country = null
        if (this.countries) {
            let countryData = this.countries.filter(c => c["alpha-2"] == countryCode)[0]
            if (countryData) country = countryData.name
        }

        let params = {
            paymentDetails: {
                amount: amount,
                firstName: firstName || null,
                lastName: lastName || null,
                message: message || null,
                contactFirstName: contactFirstName || null,
                contactLastName: contactLastName || null,
                contactEmail: contactEmail || null,
                contactPhone: contactPhone || null,
                address: [{
                    street: street || null,
                    city: city || null,
                    state: region,
                    country: country || null,
                    postcode: postcode || null
                }]
            },
            paymentIntent: this.paymentIntent || null
        };

        jQuery.ajax({
            method: 'post',
            url: ajax_var.url,
            data: {
                action: 'submit_firehawk_pay',
                params: params
            }
        }).done((res) => {
            jQuery(this.checkoutWrapper).find(".firehawk-pay-form").hide()
            jQuery(this.checkoutWrapper).find(".firehawk-pay-success").show()
            submitButton.removeClass("loading")
            this.isSubmitting = false
        }).fail((xhr, status, error) => {
            console.error("Error", error)
            errorView.html("Something has gone wrong. Please Contact us for further assistance.")
            errorView.removeClass("d-none")
            submitButton.removeClass("loading")
            this.isSubmitting = false
        })
    }

    setupStripe() {
        this.loadingStripe = true
        if (!this.hasInitialStripe) {
            jQuery(this.checkoutWrapper).find(".payment-loading-placeholder").show()
        }

        let amountValue = this.formPage1.find("input[name=amount").val()
        let amount = +(amountValue || 0)

        let params = {
            amount: amount,
            testPayment: this.useTestPayments == true
        };

        if(this.client) {
            params["client"] = this.client
        }

        if(this.type) {
            params["meta_type"] = this.type
        }

        if(this.useTestPayments) {
            params['testPayment'] = true
        }

        if(this.currency) {
            params['currency'] = currency
        }

        jQuery.ajax({
            method: 'post',
            url: ajax_var.url,
            data: {
                action: 'firehawk_pay_payment_intent',
                params: params
            }
        }).done((response) => {
            if (response && response.result && response.result.client_secret) {
                this.checkoutWrapper.find(".firehawk-pay").show()
                this.paymentIntent = response.result;
                this.elements = this.stripe.elements({
                    clientSecret: this.paymentIntent.client_secret,
                });

                this.paymentElement = this.elements.create('payment');
                this.paymentElement.mount('#fh-payment-details');

                this.paymentElement.on('change', (event) => {
                    this.paymentFormComplete = event.complete
                });

                this.hasInitialStripe = true
            }

            this.loadingStripe = false
            jQuery(this.checkoutWrapper).find(".payment-loading-placeholder").hide()
        }).fail((xhr, status, error) => {
            console.log(status, error)
            this.loadingStripe = false
            jQuery(this.checkoutWrapper).find(".payment-loading-placeholder").hide()
        })
    }
}
